"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _getUrlParam = require("@jobmatchme/utils/es/getUrlParam");

var _Authentication = require("../../provider/Authentication");

var _AppTabs = _interopRequireDefault(require("../AppTabs"));

var _VerticalSelection = _interopRequireDefault(require("../VerticalSelection"));

var _Judgements = require("../../provider/Judgements");

var _Profile = require("../../provider/Profile");

var _Vertical = require("../../provider/Vertical");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * Handle a direct application by a pc that specifically selected a
 * given joboffer (e.g. from the list of static joboffers
 */
var LikeDirect = function LikeDirect() {
  var _useContext = (0, _react.useContext)(_Judgements.JudgementsActionsContext),
      judgeMatch = _useContext.judgeMatch;

  var _useContext2 = (0, _react.useContext)(_Authentication.AuthenticationContext),
      isLoading = _useContext2.isLoading;

  var _useContext3 = (0, _react.useContext)(_Vertical.VerticalContext),
      verticals = _useContext3.verticals,
      vertical = _useContext3.vertical,
      fetchVerticals = _useContext3.fetchVerticals;

  var _useContext4 = (0, _react.useContext)(_Profile.ProfileContext),
      revision = _useContext4.revision;

  var _useContext5 = (0, _react.useContext)(_Profile.ProfileStatusContext),
      loaded = _useContext5.loaded;

  var source = 'direct';
  (0, _react.useEffect)(function () {
    if (!isLoading && vertical && loaded) {
      var jobId = (0, _getUrlParam.getUrlParam)('jobId', false);
      var jobRevision = (0, _getUrlParam.getUrlParam)('jobRevision', false);

      if (jobId && jobRevision) {
        // Send data from url to backend
        judgeMatch(_Judgements.MATCH_STATE_LIKE, jobId, jobRevision, revision, source);
      } else {
        console.error("Missing jobId \"".concat(jobId, "\" or jobRevision \"").concat(jobRevision, "\""));
      }
    }
  }, [isLoading, vertical, revision, loaded, judgeMatch]);
  (0, _react.useEffect)(function () {
    if (!isLoading && typeof verticals === 'undefined') {
      fetchVerticals(true);
    }
  }, [isLoading, verticals, fetchVerticals]);
  return isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {}) : typeof verticals !== 'undefined' && vertical && (verticals || []).includes(vertical) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppTabs.default, {
    activeTab: "likedDirect"
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_VerticalSelection.default, {
    selection: vertical,
    configKey: "simplifiedFunnelQuestions",
    initial: (verticals || []).length === 0,
    noReroute: true
  });
};

var _default = LikeDirect;
exports.default = _default;